import React, { useRef, useState } from 'react'
import './contact.css'
import Connect from '../../components/Connect/connect';
import emailjs from "emailjs-com";
import Flicker from '../../components/Custom/Flicker';
import SupportIcon from '../../components/Custom/SupportIcon';
import supabase from '../../SupaBase';

const sid = process.env.REACT_APP_ServiceID;
const tid = process.env.REACT_APP_TemplateID;
const uid = process.env.REACT_APP_UserID;

const Contact = () => {
	const [disabled, setDisabled] = useState(true);
	const [buttonState, setButtonState] = useState('ready');
	const [is60, setIs60] = useState(true);

	const formRef = useRef(null);
	const [formData, setFormData] = useState({
		name: "",
		email: "",
		message: "",
		rating: "0",
	});

	const handleChange = (e) => {
		const { name, value } = e.target;
		setFormData((prev) => ({
			...prev,
			[name]: value,
		}));
	};

	const isValid = () => {
		const uname = formData.name !== "";
		const uemail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,7}$/.test(formData.email)
		const valid = uname && uemail;

		setDisabled(!valid);
		return valid;
	}
	const handleMouseEnter = () => {
		const valid = isValid();
		if (!valid) {
			setIs60(!is60);
		}
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		const valid = isValid();
		if (!valid) {
			setIs60(!is60);
		}
		if (!formRef.current || disabled) return;

		setDisabled(true);
		setButtonState("loading");

		try {
			const result = await emailjs.sendForm(sid, tid, formRef.current, uid);
			console.log("Email sent successfully:", result.text);

			const { data, error } = await supabase.from("feedback").insert([
				{
					name: formData.name,
					email: formData.email,
					message: formData.message || null,
					rating: Number(formData.rating) || 0,
				},
			]);

			if (error) {
				console.error("Error inserting data:", error.message);
			} else {
				console.log("Data inserted successfully:", data);
			}

			setFormData({ name: "", email: "", message: "", rating: "0" });
			setButtonState("complete");

			setTimeout(() => {
				setDisabled(false);
				setButtonState("ready");
			}, 4000);
		} catch (error) {
			console.error("Error sending email:", error);
			setButtonState("ready");
			setDisabled(false);
		}
	};


	return (
		<footer id='contact'>
			<div className="login-box font-bai">
				<p>
					My <Flicker word={"Heartware"} isGlow={false} /> needs your Feedback <SupportIcon glow={!disabled} />
				</p>
				<form ref={formRef} method='post'>
					<div className="user-box">
						<input name="name" required={true} value={formData.name} onChange={handleChange} type="text" id="name" />
						<label className="text">Your Name</label>
					</div>
					<div className="user-box">
						<input name="email" required={true} value={formData.email} onChange={handleChange} type="text" id="email" />
						<label className="text">Email</label>
					</div>
					<div className="user-box msgBox">
						<label className="text">Message</label>
						<textarea name="message" value={formData.message} onChange={handleChange} cols="30" rows="10"></textarea>
					</div>
					<div className="user-box rate">
						<label className="starLabel">Rate my work : </label>
						<div className="starBox">
							<div className="rating-stars">
								<input type="radio" name="rating" value={"0"} onChange={handleChange} checked={formData.rating === "0"} id="rs0" /><label htmlFor="rs0"></label>
								<input type="radio" name="rating" value={"1"} onChange={handleChange} checked={formData.rating === "1"} id="rs1" /><label htmlFor="rs1"></label>
								<input type="radio" name="rating" value={"2"} onChange={handleChange} checked={formData.rating === "2"} id="rs2" /><label htmlFor="rs2"></label>
								<input type="radio" name="rating" value={"3"} onChange={handleChange} checked={formData.rating === "3"} id="rs3" /><label htmlFor="rs3"></label>
								<input type="radio" name="rating" value={"4"} onChange={handleChange} checked={formData.rating === "4"} id="rs4" /><label htmlFor="rs4"></label>
								<input type="radio" name="rating" value={"5"} onChange={handleChange} checked={formData.rating === "5"} id="rs5" /><label htmlFor="rs5"></label>
							</div>
						</div>
					</div>
					<button
						id="button"
						type='submit'
						className={buttonState}
						onClick={handleSubmit}
						onMouseEnter={handleMouseEnter}
						style={{
							transform: is60 ? 'translateX(0%)' : 'translateX(100%)',
							transition: 'all 0.3s ease-out'
						}}
					>
						{buttonState === 'ready' && (
							<div className="message submitMessage">
								<svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512" style={{ fill: '#00ffff' }}>
									<path d="M64 112c-8.8 0-16 7.2-16 16v22.1L220.5 291.7c20.7 17 50.4 17 71.1 0L464 150.1V128c0-8.8-7.2-16-16-16H64zM48 212.2V384c0 8.8 7.2 16 16 16H448c8.8 0 16-7.2 16-16V212.2L322 328.8c-38.4 31.5-93.7 31.5-132 0L48 212.2zM0 128C0 92.7 28.7 64 64 64H448c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128z" />
								</svg>
								<span className="button-text">Submit</span>
							</div>
						)}
						{buttonState === 'loading' && (
							<div className="message loadingMessage">
								<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19 17">
									<circle className="loadingCircle" cx="2.2" cy="10" r="1.6" />
									<circle className="loadingCircle" cx="9.5" cy="10" r="1.6" />
									<circle className="loadingCircle" cx="16.8" cy="10" r="1.6" />
								</svg>
							</div>
						)}
						{buttonState === 'complete' && (
							<div className="message successMessage">
								<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 11">
									<polyline stroke="currentColor" points="1.4,5.8 5.1,9.5 11.6,2.1 " />
								</svg> <span className="button-text">Success</span>
							</div>
						)}
					</button>
				</form>
			</div>
			<div className="division">
				<span className="line"></span>or<span className="line"></span>
			</div>
			<div className="link">
				<p className="t2">Know me more : </p>
				<Connect />
			</div>
		</footer>
	);
}

export default Contact